<template>
  <div class="travel-list-page">
    <div class="travel-list-container">
      <div class="travel-list-title">
        <span class="new-travel-titie">最新游记</span>
      </div>
      <div class="travels-content">
        <div
          class="travels-item"
          v-for="(item, index) in newTravelsList"
          :key="index"
        >
          <tr-item
            :imageUrl="processImgs(item.imgs)"
            :item="item"
            :visitPath="`/detail/new${item.id}`"
          >
            <div class="travels-info-wrap">
              <div class="travels-info-item">
                <div class="travel-title-wrap">
                  <a
                    class="travel-title"
                    :title="item.name"
                    target="_blank"
                    :href="`/detail/new${item.id}`"
                  >
                    {{
                      item.name && item.name.length > 25
                        ? `${item.name.slice(0, 25)}...`
                        : item.name
                    }}
                  </a>
                  <span :class="item.playDays?'travel-tag':''">{{ item.playDays }}{{ item.playDays?"日游":"" }}</span>
                </div>
                <p
                  class="travel-path"
                  :title="item.infoParagraphName"
                >
                  {{
                    item.infoParagraphName && item.infoParagraphName.length > 50
                      ? `${item.infoParagraphName.slice(0, 50)}...`
                      : item.infoParagraphName
                  }}
                </p>
                <p class="travel-mark">
                  <span>发表时间：{{ item.updateTime | formatTime }}</span>
                  <span>
                    <i class="el-icon-user-solid"></i>
                    &nbsp;用户：{{
                        item.nickName ? item.nickName : `用户${item.userId}`
                      }}
                  </span>
                </p>
              </div>
              <div class="travels-info-bottom">
                <div class="travel-experience-wrap">
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/icon-drive-difficulty.png" />&nbsp;
                    <span>
                      驾驶难度：{{
                        item.difficulty ? item.difficulty : "--" | getdifficulty
                      }}
                    </span>
                  </span>
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/total-mileage-colorful.png" />
                    &nbsp;总里程：{{ item.totalMileage
                    }}{{
                      item.totalMileage && item.totalMileage !== ""
                        ? "公里"
                        : "--"
                    }}
                  </span>
                  <span class="mark-item">
                    <img src="~@/assets/images/icons/icon-money.png" />
                    &nbsp;人均消费：{{ item.price ? `${item.price}元` : "--" }}
                  </span>
                </div>
              </div>
            </div>
          </tr-item>
        </div>
      </div>
      <div class="travel-page-bar">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import TrContainer from "@/components/layout/TrContainer";
import TrCard from "@/components/recommend/TrCard";
import TrItem from "@/components/travels/TrItem";
import url from "@/assets/recommend/main-image.jpg";
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../axios/api";
export default {
  filters: {
    getdifficulty: function(value) {
      if (value === "--") return "--";
      let levelMap = new Map([[1, "轻松"], [2, "适中"], [3, "困难"]]);
      return levelMap.get(value);
    },
    formatTime(value) {
      if (value) {
        return value.substring(0, value.indexOf(" "));
      } else {
        return "";
      }
    }
  },
  components: {
    TrContainer,
    TrCard,
    TrItem
  },
  computed: {
    ...mapState("NewTravelStore", ["newTravelsList", "total"])
  },
  data() {
    return {
      lastVisitPage: 1,
      message: "123123123123",
      imgUrl: url,
      page: 1,
      rows: 10
    };
  },
  created() {
    let loginUserInfo = this.$cookie.get("userInfo_userId");
    // 如果用户已经登录，则判断上次看的是第几页
    if (loginUserInfo) {
      this.page = this.$Global.lastVisitPage ? this.$Global.lastVisitPage : 1;
    }
    this.getnewTravelsList({
      page: this.page,
      rows: this.rows,
      dataType: 14,
      word: "",
      flag: 1
    });
  },
  beforeDestroy() {
    // 如果是已经登录的状态，则在离开本页的时候，不记载停留在第几页
    // 因为如果记载的话，那么用户点击首页再点最新游记会回到这页而不是第一页
    if (this.$cookie.get("userInfo_userId")) {
      delete this.$Global.lastVisitPage;
    }
  },
  methods: {
    processImgs(imgs) {
      if (imgs) {
        return imgs.split(";")[0];
      }
      return imgs;
    },
    ...mapMutations("HomeDataStore", ["formMutations"]),
    ...mapActions("NewTravelStore", ["getnewTravelsList"]),
    handleCurrentChange(page) {
      this.$Global.lastVisitPage = page;
      this.getnewTravelsList({
        page: page,
        rows: this.rows,
        dataType: 14,
        word: "",
        flag: 1
      });
    },
    detailFunction(item) {
      this.formMutations(item);
      // this.$router.push({path: `/detail/${item.id}`});
      let routeUrl = this.$router.resolve({
        path: `/detail/new${item.id}`
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lesses/main/travel/travel-list.less";
</style>
